'use client'
const validateLocalStorageExpiry = (data) => {
    if (!data)
        return false;
    const timeNow = new Date().getTime();
    if (timeNow > data.expiry) {
        return false;
    }
    return true;
};

export { validateLocalStorageExpiry };
